import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

// components
import { AnalyticsProps } from '@inplayer-org/inplayer-ui';
import { PreviewBox, Image, Title, Button, Description, ContentWrapper } from './StyledElements';

const StyledPreviewBox = styled(PreviewBox)`
  height: 48%;
  padding: 8px 5.2%;
  display: flex;
  align-items: center;
`;

const StyledImage = styled(Image)`
  width: 26%;
  padding-bottom: 26%;
  display: inline-block;
  vertical-align: middle;
`;

const StyledContentWrapper = styled(ContentWrapper)`
  width: 68%;
  margin-left: 2%;
  vertical-align: middle;
  display: inline-block;
`;

interface OwnProps extends AnalyticsProps {
  id: number;
  onBodyClick: (id: number) => void;
  isTemplateSelected: boolean;
}

const PreviewTemplate6: FunctionComponent<OwnProps> = ({ id, onBodyClick, isTemplateSelected }) => {
  const onClick = () => onBodyClick(id);

  return (
    <StyledPreviewBox onClick={onClick} isTemplateSelected={isTemplateSelected}>
      <StyledImage isTemplateSelected={isTemplateSelected} />
      <StyledContentWrapper>
        <Title />
        <Description />
        <Description />
        <Button isTemplateSelected={isTemplateSelected} />
      </StyledContentWrapper>
    </StyledPreviewBox>
  );
};

export default PreviewTemplate6;
